import axiosInstance from "../../api/axios";

// Get media
export const getMedia = async () => {
  try {
    const res = await axiosInstance.get("/media/list/");
    return { success: true, data: res.data };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.message || "Failed to fetch media.",
    };
  }
};

// Delete media
export const deleteMedia = async (id: number) => {
  try {
    await axiosInstance.delete(`/media/${id}`);
    return { success: true };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.message || "Delete failed.",
    };
  }
};

// Upload media
export const uploadMedia = async (
  files: File[],
  onProgress?: (percent: number) => void
) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));

  try {
    await axiosInstance.post("/media/upload/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (e) => {
        const percent = Math.round((e.loaded * 100) / (e.total || 1));
        onProgress?.(percent);
      },
    });
    return { success: true };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.message || "Upload failed.",
    };
  }
};
